import React from 'react';
import { graphql } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Layout } from '~/components/molecules/Layout';
import { SEO } from '~/components/atoms/SEO';
// eslint-disable-next-line import/no-cycle
import NeuropsychologyPage from '../NeuropsychologyPage/NeuropsychologyPage';
import { TranslationContext } from '~/utils/styles/utils';

const Neuropsychology: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <SEO title={t('SeoTitle')} metaDescription={t('SeoMetaDescription')} />
      <TranslationContext.Provider value={t}>
        <NeuropsychologyPage />
      </TranslationContext.Provider>
    </Layout>
  );
};

export const useTranslationContext = () => React.useContext(TranslationContext);

export default Neuropsychology;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(
      filter: { ns: { in: ["neuropsychpage"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
